module.exports = __webpack_public_path__ + "img/sg.ac975d1a.svg";